module.exports = __webpack_public_path__ + "media/images/selfpromo__sidebar--image-7728487b1b829edb68e44be854155b0e.jpg";